import { createSafeJotaiSessionStorage } from '@heidi/utils/jotai-storage';
import { getDefaultStore } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const INVITE_TEAM_STEP_COMPLETED_KEY = 'practice_invite_team_step_completed';
const PRACTICE_TRIAL_MODAL_PENDING_KEY = 'practice_trial_modal_pending';

/**
 * InviteTeamStep left (send/skip). PracticeTrialModal skips invite chain when set.
 *
 * sessionStorage: survives refresh in this tab, dies on tab close. Logout also
 * clears so a same-tab account switch can't inherit "invite already handled".
 */
export const inviteTeamStepCompletedAtom = atomWithStorage<boolean>(
  INVITE_TEAM_STEP_COMPLETED_KEY,
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

/**
 * Set at onboarding submit (team org size + practice-invite flag). Gates
 * PRACTICE_TRIAL so existing users never see the new ModalId.
 *
 * sessionStorage: survives refresh in this tab, dies on tab close. Second
 * device / new tab misses the modal — trial already active either way.
 */
export const practiceTrialModalPendingAtom = atomWithStorage<boolean>(
  PRACTICE_TRIAL_MODAL_PENDING_KEY,
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

/**
 * Logout cleanup. Flags die with the tab, but logout/login in the same tab
 * must not inherit the previous signup's invite/trial gating.
 */
export function clearPracticeInviteSessionState(): void {
  const store = getDefaultStore();
  store.set(inviteTeamStepCompletedAtom, false);
  store.set(practiceTrialModalPendingAtom, false);
}
